<template>
  <el-dialog :width=dialog.width title="文件预览" :visible.sync="dialog.show">
    <el-image style="width: 100%;" :src="dialog.url"></el-image>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialog.show = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: { show: false, width: "1200px", url: "" },
    };
  },
  methods: {
    show(url) {

      // this.dialog.url = url;
      // this.dialog.show = true;
      // return;

      //var temp = "http://localhost:5000" + url.toLowerCase();
      // var temp = "http://47.93.121.213:5001" + url.toLowerCase();
      var temp=this.$axios.defaults.baseURL+url.toLowerCase();
      if (temp.indexOf(".jpg") != -1 || temp.indexOf(".png") != -1) {
        this.dialog.url = temp;
        this.dialog.show = true;
      }
      else {
        window.open(temp);
      }
    },
  }
}
</script>
